import { useState, useEffect } from "react"
import { authFetch } from "../../utils/api"

const API = process.env.REACT_APP_API_URL
const POR_PAGINA = 5

const FORM_VACIO = { pdNombre: "", pdMatricula: "", pdEspecialidad: "" }

function GestionDoctores() {
  const [doctores, setDoctores]         = useState([])
  const [form, setForm]                 = useState(FORM_VACIO)
  const [editandoId, setEditandoId]     = useState(null)
  const [formEdit, setFormEdit]         = useState(null)
  const [mensaje, setMensaje]           = useState(null)
  const [mensajeEdit, setMensajeEdit]   = useState(null)
  const [busqueda, setBusqueda]         = useState("")
  const [pagina, setPagina]             = useState(1)

  const cargar = () =>
    authFetch(`${API}/doctores`).then(r => r.json()).then(setDoctores)

  useEffect(() => { cargar() }, [])

  const handleChange     = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }))
  const handleChangeEdit = (e) => setFormEdit(prev => ({ ...prev, [e.target.name]: e.target.value }))

  const handleAlta = async () => {
    setMensaje(null)
    try {
      const res = await authFetch(`${API}/doctores`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      })
      if (!res.ok) {
        const err = await res.json()
        setMensaje({ tipo: "error", texto: err.error || "Error al guardar" })
        return
      }
      setMensaje({ tipo: "ok", texto: "Médico registrado correctamente" })
      setForm(FORM_VACIO)
      cargar()
    } catch {
      setMensaje({ tipo: "error", texto: "Error de conexión" })
    }
  }

  const handleEditar = (d) => {
    if (editandoId === d.id) { setEditandoId(null); setFormEdit(null); setMensajeEdit(null); return }
    setEditandoId(d.id)
    setFormEdit({ pdNombre: d.pdNombre || "", pdMatricula: d.pdMatricula || "", pdEspecialidad: d.pdEspecialidad || "" })
    setMensajeEdit(null)
  }

  const handleGuardar = async () => {
    setMensajeEdit(null)
    try {
      const res = await authFetch(`${API}/doctores/${editandoId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formEdit),
      })
      if (!res.ok) {
        const err = await res.json()
        setMensajeEdit({ tipo: "error", texto: err.error || "Error al guardar" })
        return
      }
      setMensajeEdit({ tipo: "ok", texto: "Médico actualizado" })
      cargar()
    } catch {
      setMensajeEdit({ tipo: "error", texto: "Error de conexión" })
    }
  }

  const handleEliminar = async (id) => {
    if (!window.confirm("¿Eliminar este médico? Los pacientes asociados quedarán sin médico asignado.")) return
    try {
      await authFetch(`${API}/doctores/${id}`, { method: "DELETE" })
      cargar()
      if (editandoId === id) { setEditandoId(null); setFormEdit(null) }
    } catch {
      alert("Error al eliminar")
    }
  }

  const q = busqueda.toLowerCase().trim()
  const doctoresFiltrados = doctores.filter(d => {
    if (!q) return true
    if (d.pdNombre?.toLowerCase().includes(q)) return true
    return (d.pacientes || []).some(p =>
      p.apellido?.toLowerCase().includes(q) || p.nombre?.toLowerCase().includes(q)
    )
  })
  const totalPaginas    = Math.ceil(doctoresFiltrados.length / POR_PAGINA)
  const paginaActual    = Math.min(pagina, totalPaginas || 1)
  const doctoresPagina  = doctoresFiltrados.slice((paginaActual - 1) * POR_PAGINA, paginaActual * POR_PAGINA)

  return (
    <div className="adminPanel column">

      <div className="adminPanelTitle row">
        <i className="fa-solid fa-user-doctor"></i>
        GESTIÓN DE MÉDICOS
      </div>

      {/* ALTA */}
      <div className="adminSection">
        <div className="adminSectionLabel">registrar nuevo médico</div>
        <div className="adminRow">
          <div className="adminField adminField--grow">
            <label>nombre y apellido *</label>
            <input type="text" name="pdNombre" placeholder="Dr. García" value={form.pdNombre} onChange={handleChange} />
          </div>
          <div className="adminField">
            <label>matrícula</label>
            <input type="text" name="pdMatricula" placeholder="MP 12345" value={form.pdMatricula} onChange={handleChange} />
          </div>
          <div className="adminField">
            <label>especialidad</label>
            <input type="text" name="pdEspecialidad" placeholder="Clínica médica" value={form.pdEspecialidad} onChange={handleChange} />
          </div>
        </div>
        {mensaje && (
          <div className={`adminMensaje adminMensaje--${mensaje.tipo}`}>
            {mensaje.texto}
          </div>
        )}
        <div className="adminBtnRow adminBtnRow--left">
          <button className="adminBtn adminBtn--primary" onClick={handleAlta}>registrar médico</button>
        </div>
      </div>

      <div className="adminSeparador" />

      {/* LISTA */}
      <div className="adminSection adminSection--mt">
        <div className="adminSectionLabel">médicos registrados</div>

        {doctores.length === 0 ? (
          <div className="adminEmptyState">No hay médicos registrados.</div>
        ) : (
          <div className="adminPreviewBox">
            <div className="adminBusquedaRow">
              <input
                type="text"
                placeholder="buscar por médico o nombre de paciente..."
                value={busqueda}
                onChange={e => { setBusqueda(e.target.value); setEditandoId(null); setPagina(1) }}
              />
              {busqueda && (
                <span className="adminBusquedaInfo">
                  {doctoresFiltrados.length} de {doctores.length} médicos
                </span>
              )}
            </div>

            <table className="adminPreviewTable">
              <thead>
                <tr>
                  <th></th>
                  <th>nombre</th>
                  <th>matrícula</th>
                  <th>especialidad</th>
                  <th>pacientes</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {doctoresPagina.length === 0 ? (
                  <tr><td colSpan={6}><div className="adminEmptyState">sin resultados</div></td></tr>
                ) : doctoresPagina.map(d => (
                  <>
                    <tr key={d.id} className={editandoId === d.id ? "usuarioRowActiva" : ""}>
                      <td>
                        <button
                          className={`usuarioEditBtn${editandoId === d.id ? " usuarioEditBtn--active" : ""}`}
                          onClick={() => handleEditar(d)}
                          title="editar"
                        >
                          <i className={`fa-solid fa-${editandoId === d.id ? "xmark" : "pen"}`}></i>
                        </button>
                      </td>
                      <td>{d.pdNombre}</td>
                      <td>{d.pdMatricula    || <span className="adminPlaceholder">—</span>}</td>
                      <td>{d.pdEspecialidad || <span className="adminPlaceholder">—</span>}</td>
                      <td>{d._count?.pacientes ?? 0}</td>
                      <td>
                        <button
                          className="usuarioEditBtn adminDanger"
                          onClick={() => handleEliminar(d.id)}
                          title="eliminar"
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      </td>
                    </tr>

                    {editandoId === d.id && formEdit && (
                      <tr key={`${d.id}-form`} className="usuarioFormRow">
                        <td colSpan={6}>
                          <div className="usuarioFormInline">
                            <div className="adminSection">
                              <div className="adminSectionLabel">editar médico</div>
                              <div className="adminRow">
                                <div className="adminField adminField--grow">
                                  <label>nombre y apellido *</label>
                                  <input type="text" name="pdNombre" value={formEdit.pdNombre} onChange={handleChangeEdit} />
                                </div>
                                <div className="adminField">
                                  <label>matrícula</label>
                                  <input type="text" name="pdMatricula" value={formEdit.pdMatricula} onChange={handleChangeEdit} />
                                </div>
                                <div className="adminField">
                                  <label>especialidad</label>
                                  <input type="text" name="pdEspecialidad" value={formEdit.pdEspecialidad} onChange={handleChangeEdit} />
                                </div>
                              </div>
                            </div>
                            {mensajeEdit && (
                              <div className={`adminMensaje adminMensaje--${mensajeEdit.tipo}`}>
                                {mensajeEdit.texto}
                              </div>
                            )}
                            <div className="adminBtnRow">
                              <button className="adminBtn adminBtn--primary" onClick={handleGuardar}>guardar cambios</button>
                              <button className="adminBtn" onClick={() => { setEditandoId(null); setFormEdit(null); setMensajeEdit(null) }}>cancelar</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {totalPaginas > 1 && (
        <div className="adminPaginacion">
          <button className="adminBtn" onClick={() => { setPagina(p => p - 1); setEditandoId(null) }} disabled={paginaActual === 1}>{"<"}</button>
          <span className="adminPaginacionInfo">{paginaActual} / {totalPaginas}</span>
          <button className="adminBtn" onClick={() => { setPagina(p => p + 1); setEditandoId(null) }} disabled={paginaActual === totalPaginas}>{">"}</button>
        </div>
      )}

    </div>
  )
}

export default GestionDoctores
